<template>
  <div class="ai-conv-list">
    <div class="ai-conv-header">
      <span class="ai-conv-title">小盟AI</span>
    </div>

    <div class="ai-conv-new">
      <el-button type="primary" class="ai-new-btn" @click="$emit('create')">
        <i class="el-icon-plus"></i>
        <span>新建对话</span>
      </el-button>
    </div>

    <div v-loading="loading" class="ai-conv-scroll">
      <div
        v-for="item in sessions"
        :key="item.sessionId"
        class="ai-conv-item"
        :class="{ 'is-active': item.sessionId === activeId }"
        :title="item.topic || '新对话'"
        @click="$emit('select', item.sessionId)"
      >
        <span class="ai-conv-item-text">{{ item.topic || "新对话" }}</span>
      </div>

      <div v-if="!loading && !sessions.length" class="ai-conv-empty">
        暂无历史对话
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConversationList",
  props: {
    sessions: { type: Array, default: () => [] },
    activeId: { type: String, default: "" },
    loading: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.ai-conv-list {
  width: 273px;
  flex: 0 0 273px;
  height: 100%;
  background: #fff;
  border-right: 1px solid #e5e6eb;
  padding: 16px 12px 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.ai-conv-header {
  padding: 0 8px 14px;
}

.ai-conv-title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}

.ai-conv-new {
  padding: 0 4px 10px;
}

.ai-new-btn {
  width: 100%;
}

.ai-conv-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 2px 4px 8px;
}

.ai-conv-item {
  height: 58px;
  display: flex;
  align-items: center;
  padding: 8px;
  margin-bottom: 3px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  color: #1d2129;
  box-sizing: border-box;
  transition: background 0.15s;
}

.ai-conv-item:hover {
  background: #f7f8fa;
}

/* 选中态：实测自 avue assistant */
.ai-conv-item.is-active {
  background: #e5f0ff;
}

.ai-conv-item-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ai-conv-empty {
  text-align: center;
  color: #86909c;
  font-size: 13px;
  padding: 30px 0;
}
</style>
